export default "__VITE_ASSET__DZfii$xh__"